import React from "react";
import Slider from "react-slick";
import { Container } from "react-grid-system";
import { FaReact, FaAngular, FaVuejs, FaLaravel, FaAndroid, FaAppStoreIos, FaWordpress, FaNodeJs } from "react-icons/fa";

const service = [
    {
        key: "react",
        title: "ReactJs",
        subtitle: "Experience in front-end to create a robust and effective application",
        link: "/service-details",
        icon: "ti-ruler-alt-2",
    },
    {
        key: "angular",
        title: "AngularJs",
        subtitle: "Experience in front-end to create a robust and effective application",
        link: "/service-details",
        icon: "ti-ruler-pencil",
    },
    {
        key: "vue",
        title: "VueJs",
        subtitle: "Experience in front-end to create a robust and effective application",
        link: "/service-details",
        icon: "ti-paint-bucket",
    },
    {
        key: "laravel",
        title: "Laravel Framework",
        subtitle: "Experience in secure web based application and api development",
        link: "/service-details",
        icon: "ti-cup",
    },
    {
        key: "android",
        title: "Android Development",
        subtitle: "Experience in android application developer",
        link: "/service-details",
        icon: "ti-image",
    },
    {
        key: "ios",
        title: "IOS Development",
        subtitle: "Experience in IOS application developer",
        link: "/service-details",
        icon: "ti-brush-alt",
    },
    {
        key: "wordpress",
        title: "Wordpress",
        subtitle: "Experience in wordpress development like plugin, page-build, woo-commerce, etc",
        link: "/service-details",
        icon: "ti-brush-alt",
    },
    {
        key: "node",
        title: "NodeJs",
        subtitle: "Experience in real-time, socket, chat, api application",
        link: "/service-details",
        icon: "ti-brush-alt",
    },
];

function Service() {
    let sliderSettings = {
        dots: true,
        speed: 500,
        arrows: false,
        infinite: true,
        initialSlide: 0,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: 50,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 100,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    let generateIcon = (item) => {
        switch(item.title) {
            case 'ReactJs':
                return <FaReact className="icon el-icon-icon" />
            case 'AngularJs':
                return <FaAngular className="icon el-icon-icon" />
            case 'VueJs':
                return <FaVuejs className="icon el-icon-icon" />
            case 'Laravel Framework':
                return <FaLaravel className="icon el-icon-icon" />
            case 'Android Development':
                return <FaAndroid className="icon el-icon-icon" />
            case 'IOS Development':
                return <FaAppStoreIos className="icon el-icon-icon" />
            case 'Wordpress':
                return <FaWordpress className="icon el-icon-icon" />
            case 'NodeJs':
                return <FaNodeJs className="icon el-icon el-icon-icon" />
            default:
                return <span className={`el-icon-icon ${item.icon}`}></span>
        }
    }

    return (
        <section className="section section-service section-service-5">
            <div className="display-spacing mb-0">
                <Container>
                    <header className="el-heading el-heading-center">
                        <div className="el-icon">
                            <h2 className="el-icon-title">
                                <span>SERVICE</span>
                            </h2>
                        </div>
                        <h3>Let's See My Services</h3>
                        <div className="divider divider-1-reverse divider-1-1"></div>
                        <div className="divider divider-1-reverse divider-1-2"></div>
                    </header>
                    <Slider className="el-slider el-slider-plr--15 mb-30" {...sliderSettings}>
                        {service.map((item, index) => (
                            <div className="service-wrap" key={index}>
                                <div className={`service-item ${item.key}`}>
                                    <div className="service-head">
                                        {generateIcon(item)}
                                    </div>
                                    <div className="service-body">
                                        <h3>{item.title}</h3>
                                        <p>{item.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </Container>
            </div>
        </section>
    );
}

export default Service;
